import React from "react";

import { FaArrowCircleUp } from "react-icons/fa";
import { animateScroll as Scroll } from "react-scroll";

import "../css/backToTop.css";
const BackToTop = () => {
	window.addEventListener('scroll', () => {
		const backToTop = document.getElementById("backToTop");

		backToTop.classList.toggle("backToTop--active", window.scrollY > 500);
	});

	return <FaArrowCircleUp title="Up" id="backToTop" className="backToTop" onClick={Scroll.scrollToTop} />
}

export default BackToTop
